import { getAccessToken } from 'cng-common/helpers/access'
import { IForm } from 'core-components/classes/models/IForm'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchPartnerAllDataRegionsRows = async (partnerId: string): Promise<IForm[]> => {
  const url = proxy('/webservice/621/sp/v4/spPartnerAllDataRegions/call')
  const accessToken = getAccessToken()
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerID': partnerId,
  }

  const response = await Rest.post({ url, payload, headers })
  return Array.isArray(response?.Data) ? response.Data : []
}
